/**
 * どの機能にも属さないルートのパス定義（ホーム・廃止した横断検索の倒し先）。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business どの機能にも属さないルート（ホーム・廃止した横断検索）のパスを定義する。
 * @graph-connects none
 */
import type { FeatureRouteSets } from './feature-route-sets.js';

/**
 * ホーム。PJ 一覧へ倒す。
 *
 * この画面群の主語は PJ なので、入口は PJ 一覧である。`/` に別の内容を置くと「PJ を選ばずに
 * 眺める場所」が生まれ、PJ が上位の軸だという構造がリンクごとの運用で崩れる。ルート自体は
 * 残す。消すと既存のブックマークが 404 になる（`frontend.md` の「深いリンクから到達した URL は
 * 404 を出さない」）。
 * @graph-connects none
 */
export const HOME_ROUTE = '/';

/**
 * 廃止した横断検索。PJ 一覧へ倒す。
 *
 * 画面は廃止したが**パスは残す**。廃止前の横断検索は検索語とノード型を検索パラメータに置き、
 * 「結果 URL をそのまま共有できるように」設計してあった。したがって `/search?q=...` は
 * 共有・ブックマークされている前提で扱う必要があり、ルートごと消すと退避先の無い 404 になる
 * （`frontend.md` の「深いリンクから到達した URL は 404 を出さない」）。`/` と同じ扱いにする。
 *
 * 検索そのものは各一覧の中の絞り込みへ移した。検索語を引き継がないのは、移した先が
 * 「どの一覧を絞るか」を先に決める形になっており、型を跨いだ検索語の行き先が定まらないためである。
 * @graph-connects none
 */
export const SEARCH_ROUTE = '/search';

/** どの機能にも属さないルートの集合。どちらも PJ・操作を受けない。 @graph-connects none */
export const commonRouteSets = {
  all: [HOME_ROUTE, SEARCH_ROUTE],
  pjSearch: [],
  operationSearch: [],
  pjPath: [],
} as const satisfies FeatureRouteSets;
